<template>
	<div class="container">
		<div class="content">
			<div class="breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item replace :to="{ path: '/insure/index' }">保险产品</el-breadcrumb-item>
					<el-breadcrumb-item replace :to="{ path: '/insure/detail?id=' + data.id }">产品详情</el-breadcrumb-item>
					<el-breadcrumb-item>填写保单</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<div class="header">
				<div class="header-left">
					<div class="header-title">
						{{ data.name }}
					</div>
					<div class="header-value">
						由{{ data.insurer_name }}承保
					</div>
				</div>
				<div class="header-right" v-if="data.specs && data.specs[form.specsIndex]">
					<el-dropdown trigger="click">
						<span class="el-dropdown-link">
							{{ data.specs[form.specsIndex].name }}
							<i class="el-icon-arrow-right"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="(item, index) in data.specs" :key="index">
								<div @click="clickSpecs(index)">{{ item.name }}</div>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>

			<div class="box">
				<div class="box-header">
					<div class="box-header-left">
						<div class="box-title">
							保险周期
						</div>
						<div class="box-tips" @click="showInvoiceExplanation">
							<i class="el-icon-warning"></i>开票说明
						</div>
					</div>
				</div>

				<el-form :inline="true" class="form">
					<el-form-item label="投保日期" size="medium">
						<el-date-picker v-model="form.pln_date" type="daterange" :picker-options="pickerOptions"
							value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期" @change="changeDate" />
					</el-form-item>
					<el-form-item label="起保时刻" size="medium">
						<el-time-select v-model="form.pln_time"
							:picker-options="{start: '00:00', step: '01:00', end: '23:00'}" placeholder="选择时间">
						</el-time-select>
					</el-form-item>
					<el-form-item label="保险周期" size="medium">
						<el-input-number @change="daysChange" size="small" v-model="form.insured_days" :min="1" :max="maxInsuredDays"/>
						<span class="max-days-tip" v-if="maxInsuredDays > 0">（最长投保{{ maxInsuredDays }}天）</span>
					</el-form-item>
				</el-form>
			</div>

			<div class="box">
				<div class="box-header">
					<div class="box-header-left">
						<div class="box-title">
							投保人信息
						</div>
						<div class="box-tips" @click="showApplicantVerificationExplanation">
							<i class="el-icon-warning"></i>身份校验说明
						</div>
					</div>
					<div class="box-header-right">
						<div class="operate" @click="showHistoricalApplicants">
							历史投保人
						</div>
					</div>
				</div>

				<div class="invoice-tips">
					发票抬头必须与投保人信息一致，提交订单前请仔细核对
				</div>

				<el-form :inline="true" class="form">
					<el-form-item label="投保人类型" size="medium">
						<el-radio @input="inputApplicantType" v-model="form.applicant_info.applicant_type" :label="0"
							fill="#2280FD">
							个人
						</el-radio>
						<el-radio @input="inputApplicantType" v-model="form.applicant_info.applicant_type" :label="1"
							fill="#2280FD">
							企业
						</el-radio>
					</el-form-item>
				</el-form>
				<div v-if="form.applicant_info.applicant_type == 0">
					<el-form :inline="true" class="form">
						<el-form-item label="投保人姓名" size="medium">
							<el-input v-model="form.applicant_info.applicant_name" placeholder="请输入投保人姓名" />
						</el-form-item>
						<el-form-item label="证件类型" size="medium">
							<el-radio v-model="form.applicant_info.applicant_id_type" :label="0" fill="#2280FD">
								身份证
							</el-radio>
							<el-radio v-model="form.applicant_info.applicant_id_type" :label="1" fill="#2280FD">
								护照
							</el-radio>
							<el-radio v-model="form.applicant_info.applicant_id_type" :label="3" fill="#2280FD">
								港澳内地通行证
							</el-radio>
							<el-radio v-model="form.applicant_info.applicant_id_type" :label="4" fill="#2280FD">
								台湾大陆通行证
							</el-radio>
						</el-form-item>
						<el-form-item label="证件号码" size="medium">
							<el-input v-model="form.applicant_info.applicant_id_number" placeholder="请输入证件号码" />
						</el-form-item>
						<el-form-item label="联系电话" size="medium">
							<el-input v-model="form.applicant_info.applicant_phone" placeholder="请输入联系电话" />
						</el-form-item>
					</el-form>
				</div>
				<div v-if="form.applicant_info.applicant_type == 1">
					<el-form :inline="true" class="form">
						<el-form-item label="企业名称" size="medium">
							<el-input v-model="form.applicant_info.applicant_name" placeholder="请输入企业全称" />
						</el-form-item>
						<el-form-item label="证件类型" size="medium">
							<el-radio v-model="form.applicant_info.applicant_id_type" :label="2" fill="#2280FD">
								统一社会信用代码
							</el-radio>
						</el-form-item>
						<el-form-item label="证件号码" size="medium">
							<el-input v-model="form.applicant_info.applicant_id_number" placeholder="请输入统一社会信用代码" />
						</el-form-item>
						<el-form-item label="联系人" size="medium">
							<el-input v-model="form.applicant_info.applicant_contact_name" placeholder="请输入联系人" />
						</el-form-item>
						<el-form-item label="联系电话" size="medium">
							<el-input v-model="form.applicant_info.applicant_phone" placeholder="请输入联系电话" />
						</el-form-item>
					</el-form>
				</div>
			</div>

			<div class="box">
				<div class="box-header">
					<div class="box-header-left">
						<div class="box-title">
							被保人信息
						</div>
						<div class="box-tips" @click="showInsuredVerificationExplanation">
							<i class="el-icon-warning"></i>身份校验说明
						</div>
					</div>
					<div class="box-header-right">
						<!-- 添加上传名单按钮 -->
						<div class="operate" @click="triggerUpload">
							上传名单
						</div>
						<div class="operate-line"></div>
						<div class="operate" @click="downloadTemplate">
							下载模版
						</div>
						<div class="operate-line"></div>
						<div class="operate" @click="insuredListShow = true">
							粘贴名单
						</div>
						<div class="operate-line"></div>
						<div class="operate" @click="addInsured">
							添加被保人
						</div>
						<div class="operate-line"></div>
						<div class="operate" @click="exportAllInsured">
							导出全部人员
						</div>
						<div class="operate-line"></div>
						<div class="operate del" @click="deleteAllInsured">
							删除全部
						</div>
					</div>
				</div>

				<!-- 文件上传组件 - 隐藏 -->
				<el-upload ref="excelUpload" class="excel-upload" action="#" :before-upload="beforeExcelUpload"
					:show-file-list="false" :multiple="false" accept=".xlsx,.xls,.csv" style="display: none;">
				</el-upload>

				<div class="user-list">
					<div class="user-item" v-for="(item, index) in form.insured" :key="item.id || index">
						<div class="user-info">
							<div class="user-name">
								{{ item.isrd_name }}
							</div>
							<div class="user-id">
								{{ item.isrd_cret_code }}
							</div>
						</div>
						<div class="user-operate">
							<div class="user-operate-btn" @click="modifyInsured(item)">
								修改
							</div>
							<div class="user-operate-btn del" @click="deleteInsured(index)">
								删除
							</div>
						</div>
					</div>
					<div class="empty-tips" v-if="form.insured.length === 0">
						暂无被保人信息，请点击"添加被保人"进行添加
					</div>
				</div>
			</div>

			<div class="box">
				<div class="box-header">
					<div class="box-header-left">
						<div class="box-title">
							备注信息
						</div>
					</div>
				</div>

				<el-input v-model="form.remark" class="textarea" type="textarea" :rows="8" placeholder="请输入备注信息" />
			</div>

			<div class="box">
				<div class="box-header">
					<div class="box-header-left">
						<div class="box-title">
							其他设置
						</div>
					</div>
				</div>

				<el-form :inline="true" class="form" label-width="130px">
					<el-form-item label="投保人短信通知" size="medium">
						<el-switch v-model="form.sms_notify_policyholder" :active-value="1" :inactive-value="0"
							active-color="#2280FD" />
					</el-form-item>
				</el-form>

				<div class="explain">
					{{ $getter('setting').value6 }}
				</div>

				<div class="read">
					<i @click="agreement.a = !agreement.a" class="el-icon-success"
						:style="{color: agreement.a ? '#2280FD' : ''}"></i>
					<div class="text">
						本人充分阅读、理解并同意
						<span>《保险条款》、</span>
						<span>《投保声明》、</span>
						<span>《个人信息保护政策》、</span>
						<span>《身保险伤残评定标准及代码》</span>
					</div>
				</div>

				<div class="read">
					<i @click="agreement.b = !agreement.b" class="el-icon-success"
						:style="{color: agreement.b ? '#2280FD' : ''}"></i>
					<div class="text">
						本人已逐页阅读并同意
						<span>《免责内容》、</span>
						<span>《被保险人同意声明》、</span>
						<span>《特别约定》</span>
					</div>
				</div>
			</div>
		</div>

		<!-- 被保人信息弹窗 -->
		<el-dialog :title="insured.isEdit ? '修改被保人信息' : '添加被保人信息'" width="35%" :visible.sync="insuredShow">
			<el-form label-width="80px">
				<el-form-item label="姓名" size="medium">
					<el-input v-model="insured.isrd_name" placeholder="请输入姓名" />
				</el-form-item>
				<el-form-item label="证件类型" size="medium">
					<el-radio v-model="insured.isrd_cret_type" :label="0" fill="#2280FD">
						身份证
					</el-radio>
					<el-radio v-model="insured.isrd_cret_type" :label="1" fill="#2280FD">
						护照
					</el-radio>
					<el-radio v-model="insured.isrd_cret_type" :label="3" fill="#2280FD">
						港澳内地通行证
					</el-radio>
					<el-radio v-model="insured.isrd_cret_type" :label="4" fill="#2280FD">
						台湾大陆通行证
					</el-radio>
				</el-form-item>
				<el-form-item label="证件号码" size="medium">
					<el-input v-model="insured.isrd_cret_code" placeholder="请输入证件号码" />
				</el-form-item>
				<el-form-item label="手机号" size="medium">
					<el-input v-model="insured.isrd_telnumber" placeholder="请输入手机号" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="insuredShow = false">取 消</el-button>
				<el-button type="primary" @click="saveInsured()">保 存</el-button>
			</div>
		</el-dialog>

		<!-- 粘贴名单弹窗 -->
		<el-dialog title="粘贴名单" width="50%" :visible.sync="insuredListShow">
			<div class="paste-tips">
				<div class="tip-title">粘贴规则：</div>
				<div class="tip-content">
					<p>一行一个人员信息，信息用空格分隔（姓名 证件类型 证件号码 联系电话）</p>
					<p><strong>支持英文名带空格的情况：</strong></p>
					<p><strong>中文名示例：</strong>张三 身份证 320125198006030000 13800138000</p>
					<p><strong>英文名示例：</strong>Bruce Lee 护照 L23485839 13800138001</p>
					<p><strong>复杂姓名示例：</strong>Maria Garcia Lopez 护照 MG1234567 13800138002</p>
					<p><strong>港澳居民往来内地通行证示例：</strong>李四 港澳居民往来内地通行证 H12345678A 13800138003</p>
					<p><strong>台湾居民往来大陆通行证示例：</strong>王五 台湾居民往来大陆通行证 12345678A 13800138004</p>
				</div>
			</div>
			<el-input v-model="insuredList" class="textarea" type="textarea" :rows="12" placeholder="请按照上述规则粘贴名单..." />
			<div slot="footer" class="dialog-footer">
				<el-button @click="clearInsuredList">清 空</el-button>
				<el-button @click="insuredListShow = false">取 消</el-button>
				<el-button type="primary" @click="saveInsuredList()">保 存</el-button>
			</div>
		</el-dialog>

		<!-- 历史投保人弹窗 -->
		<el-dialog title="历史投保人" width="45%" :visible.sync="historicalApplicantsShow">
			<div class="historical-applicants">
				<!-- 搜索框 -->
				<div class="search-box">
					<el-input
						v-model="historicalSearch"
						placeholder="搜索投保人姓名、手机号或证件号码"
						prefix-icon="el-icon-search"
						clearable
						@clear="loadHistoricalApplicants"
						@keyup.enter.native="loadHistoricalApplicants"
					>
						<el-button slot="append" icon="el-icon-search" @click="loadHistoricalApplicants">搜索</el-button>
					</el-input>
				</div>

				<!-- 投保人列表 -->
				<div class="applicants-list">
					<div 
						v-for="applicant in historicalApplicants" 
						:key="applicant.applicant_id_number + applicant.latest_created_at"
						class="applicant-item"
						@click="selectHistoricalApplicant(applicant)"
					>
						<div class="applicant-info">
							<div class="applicant-name">{{ applicant.applicant_name }}</div>
							<div class="applicant-details">
								<span class="applicant-type">{{ applicant.applicant_type === 0 ? '个人' : '企业' }}</span>
								<span class="applicant-id">证件: {{ applicant.masked_id_number }}</span>
								<span class="applicant-phone">电话: {{ applicant.applicant_phone }}</span>
								<span class="applicant-time">最近使用: {{ formatDate(applicant.latest_created_at) }}</span>
							</div>
						</div>
						<div class="applicant-action">
							<el-button type="primary" size="small" @click.stop="selectHistoricalApplicant(applicant)">使用</el-button>
						</div>
					</div>

					<!-- 空状态 -->
					<div v-if="historicalApplicants.length === 0 && !historicalLoading" class="empty-state">
						<i class="el-icon-document"></i>
						<p>暂无历史投保人记录</p>
					</div>

					<!-- 加载状态 -->
					<div v-if="historicalLoading" class="loading-state">
						<i class="el-icon-loading"></i>
						<p>加载中...</p>
					</div>

					<!-- 分页 -->
					<div v-if="historicalPageInfo.count > 0" class="pagination">
						<el-pagination
							small
							layout="prev, pager, next, total"
							:total="historicalPageInfo.count"
							:page-size="historicalPageInfo.size"
							:current-page="historicalPageInfo.page"
							@current-change="handleHistoricalPageChange"
						/>
					</div>
				</div>
			</div>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="historicalApplicantsShow = false">关闭</el-button>
			</div>
		</el-dialog>

		<div class="bottom">
			<div class="amount">
				￥{{ calculatedAmount }}<span>元</span>
			</div>
			<div class="bottom-btn" @click="createOrder(form)">
				立即投保
			</div>
		</div>
	</div>
</template>

<script>
	import * as XLSX from 'xlsx';

	export default {
		data() {
			return {
				form: {
					pln_date: [],
					pln_time: '00:00',
					insured_days: 0,
					applicant_info: {
						applicant_type: 0,
						applicant_name: '',
						applicant_id_type: 0,
						applicant_id_number: '',
						applicant_contact_name: '',
						applicant_phone: '',
					},
					sms_notify_policyholder: 0,
					specsIndex: 0,
					insured: [],
				},
				pickerOptions: {
					disabledDate: (time) => {
						const today = new Date();
						return time.getTime() < today.getTime();
					},
				},
				agreement: {
					a: false,
					b: false,
				},
				data: {},
				insuredShow: false,
				insured: {
					isrd_name: '',
					isrd_cret_type: 0,
					isrd_cret_code: '',
					isrd_telnumber: '',
					isEdit: false
				},
				insuredList: '',
				insuredListShow: false,
				uploadLoading: null,
				calculatedAmount: '0.00', // 存储计算后的金额
				
				// 历史投保人相关数据
				historicalApplicantsShow: false,
				historicalApplicants: [],
				historicalSearch: '',
				historicalLoading: false,
				historicalPageInfo: {
					page: 1,
					size: 10,
					count: 0
				}
			}
		},
		computed: {
			// 计算最长投保天数
			maxInsuredDays() {
				if (!this.data.specs || !this.data.specs[this.form.specsIndex]) {
					return 0;
				}
				
				const specs = this.data.specs[this.form.specsIndex];
				if (!specs.price_items || specs.price_items.length === 0) {
					return 0;
				}
				
				// 获取价格表中最大的 max_days
				let maxDays = 0;
				specs.price_items.forEach(item => {
					if (item.max_days > maxDays) {
						maxDays = item.max_days;
					}
				});
				
				return maxDays;
			}
		},
		watch: {
			// 监听规格变化
			'form.specsIndex': {
				handler() {
					this.calculateAmount();
					// 更新保险天数限制
					this.updateInsuredDaysLimit();
				},
				immediate: true
			},
			// 监听保险天数变化
			'form.insured_days': {
				handler() {
					this.calculateAmount();
				},
				immediate: true
			},
			// 监听被保人列表变化
			'form.insured': {
				handler() {
					this.calculateAmount();
				},
				deep: true,
				immediate: true
			},
			// 监听产品数据加载完成
			'data.specs': {
				handler() {
					this.calculateAmount();
					// 更新保险天数限制
					this.updateInsuredDaysLimit();
				},
				deep: true,
				immediate: true
			}
		},
		mounted() {
			this.init(this.$route.query);
		},
		methods: {
			// 计算金额的方法 - 修改为根据 price_items 计算
			calculateAmount() {
				// 等待数据加载完成
				if (!this.data.specs || !this.data.specs[this.form.specsIndex]) {
					this.calculatedAmount = '0.00';
					return;
				}

				const specs = this.data.specs[this.form.specsIndex];
				const insuredDays = this.form.insured_days || 0;
				const insuredCount = this.form.insured.length || 0;

				// 如果没有价格表或价格表为空
				if (!specs.price_items || specs.price_items.length === 0) {
					this.calculatedAmount = '0.00';
					return;
				}

				// 在价格表中查找匹配的价格
				let matchedPrice = 0;
				for (const priceItem of specs.price_items) {
					if (insuredDays >= priceItem.min_days && insuredDays <= priceItem.max_days) {
						matchedPrice = parseFloat(priceItem.price) || 0;
						break;
					}
				}

				// 如果天数超过最大范围，使用最后一个价格段的价格
				if (matchedPrice === 0 && specs.price_items.length > 0) {
					const lastItem = specs.price_items[specs.price_items.length - 1];
					if (insuredDays > lastItem.max_days) {
						matchedPrice = parseFloat(lastItem.price) || 0;
					}
				}

				// 计算总金额：匹配到的价格 × 人数
				const totalAmount = matchedPrice * insuredCount;

				// 保留2位小数
				this.calculatedAmount = totalAmount.toFixed(2);
			},

			// 更新保险天数限制
			updateInsuredDaysLimit() {
				if (this.maxInsuredDays > 0 && this.form.insured_days > this.maxInsuredDays) {
					this.form.insured_days = this.maxInsuredDays;
					this.$message.warning(`保险天数不能超过${this.maxInsuredDays}天`);
				}
			},

			// 历史投保人相关方法
			showHistoricalApplicants() {
				this.historicalApplicantsShow = true;
				this.loadHistoricalApplicants();
			},

			// 加载历史投保人数据
			async loadHistoricalApplicants() {
				this.historicalLoading = true;
				try {
					const params = {
						_page: this.historicalPageInfo.page,
						_size: this.historicalPageInfo.size
					};

					// 如果有搜索关键词，添加到参数中
					if (this.historicalSearch) {
						params.keyword = this.historicalSearch;
					}

					const response = await this.$get('getPolicyApplicants', params);
					this.historicalApplicants = response.data || [];
					this.historicalPageInfo = response.pageInfo || this.historicalPageInfo;
				} catch (error) {
					this.$message.error('加载历史投保人失败');
					this.historicalApplicants = [];
				} finally {
					this.historicalLoading = false;
				}
			},

			// 选择历史投保人
			selectHistoricalApplicant(applicant) {
				// 填充投保人表单
				this.form.applicant_info = {
					applicant_type: applicant.applicant_type,
					applicant_name: applicant.applicant_name,
					applicant_id_type: applicant.applicant_id_type,
					applicant_id_number: applicant.applicant_id_number,
					applicant_phone: applicant.applicant_phone,
					applicant_contact_name: applicant.applicant_contact_name || ''
				};

				this.$message.success(`已选择投保人: ${applicant.applicant_name}`);
				this.historicalApplicantsShow = false;
			},

			// 分页变化处理
			handleHistoricalPageChange(page) {
				this.historicalPageInfo.page = page;
				this.loadHistoricalApplicants();
			},

			// 格式化日期
			formatDate(dateString) {
				if (!dateString) return '';
				const date = new Date(dateString);
				return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
			},

			// 新增：显示开票说明弹窗
			showInvoiceExplanation() {
				this.$alert(this.$getter('setting').value11, '开票说明', {
					dangerouslyUseHTMLString: true,
					customClass: 'explanation-message-box',
					confirmButtonText: '我知道了',
					callback: action => {}
				});
			},

			// 新增：显示投保人身份校验说明弹窗
			showApplicantVerificationExplanation() {
				this.$alert(this.$getter('setting').value12, '投保人身份校验说明', {
					dangerouslyUseHTMLString: true,
					customClass: 'explanation-message-box',
					confirmButtonText: '我知道了',
					callback: action => {}
				});
			},

			// 新增：显示被保人身份校验说明弹窗
			showInsuredVerificationExplanation() {
				this.$alert(this.$getter('setting').value13, '被保人身份校验说明', {
					dangerouslyUseHTMLString: true,
					customClass: 'explanation-message-box',
					confirmButtonText: '我知道了',
					callback: action => {}
				});
			},

			inputApplicantType(e) {
				if (e == 0) {
					this.form.applicant_info.applicant_id_type = 0;
				} else {
					this.form.applicant_info.applicant_id_type = 2;
				}
			},
			init(query) {
				if (!query || !query.insured_days) {
					return;
				}
				this.form.insured_days = this.$toInt(query.insured_days) || 0;
				this.form.specsIndex = query.specsIndex;
				this.calculateDates(this.form.insured_days);
				this.getData(query.id);
			},
			getData(id) {
				if (!id) return;
				this.$load();
				this.$get('app-goods/' + id).then(res => {
					this.data = res.data;
				}).catch(err => {
					this.$message.error(err);
				})
			},
			clickSpecs(index) {
				// 先清空日期选择器
				const oldDate = this.form.pln_date;
				
				this.form.specsIndex = index;
				
				this.$nextTick(() => {
					if (this.maxInsuredDays > 0) {
						// 调整天数
						if (this.form.insured_days > this.maxInsuredDays) {
							this.form.insured_days = this.maxInsuredDays;
						}
						
						// 重新设置日期
						if (oldDate && oldDate[0]) {
							const startDate = new Date(oldDate[0]);
							const endDate = this.addDays(startDate, this.form.insured_days);
							
							// 延迟设置确保组件更新
							setTimeout(() => {
								this.form.pln_date = [
									oldDate[0],
									this.$formatDate(endDate, 'YYYY-MM-DD')
								];
							}, 100);
						}
					}
					this.calculateAmount();
				});
			},
			calculateDates(insuredDays) {
				const days = this.$toInt(insuredDays);
				if (days <= 0) return;

				const startDate = this.getTomorrow();
				const endDate = this.addDays(startDate, days);

				this.form.pln_date = [
					this.$formatDate(startDate, 'YYYY-MM-DD'),
					this.$formatDate(endDate, 'YYYY-MM-DD')
				];
			},
			changeDate(dateRange) {
				if (!dateRange || dateRange.length !== 2) {
					this.form.insured_days = 0;
					return;
				}
				
				var insured_days = this.getDaysBetweenDates(dateRange[0], dateRange[1]);
				
				// 如果超过了最大天数，自动调整为最大天数
				if (this.maxInsuredDays > 0 && insured_days > this.maxInsuredDays) {
					// 保持开始日期不变，结束日期调整为开始日期 + 最大天数
					const startDate = new Date(dateRange[0]);
					const endDate = this.addDays(startDate, this.maxInsuredDays);
					
					this.form.pln_date = [
						this.$formatDate(startDate, 'YYYY-MM-DD'),
						this.$formatDate(endDate, 'YYYY-MM-DD')
					];
					
					// 更新保险天数
					this.form.insured_days = this.maxInsuredDays;
					this.$message.warning(`保险天数不能超过${this.maxInsuredDays}天`);
				} else {
					// 正常情况，直接更新保险天数
					this.form.insured_days = insured_days;
				}
			},
			daysChange(insuredDays) {
				const days = this.$toInt(insuredDays);
				if (days <= 0 || !this.form.pln_date[0]) return;
			
				// 检查是否超过最大天数限制
				const finalDays = Math.min(days, this.maxInsuredDays > 0 ? this.maxInsuredDays : days);
				
				const startDate = new Date(this.form.pln_date[0]);
				const endDate = this.addDays(startDate, finalDays);
			
				this.form.pln_date = [
					this.form.pln_date[0],
					this.$formatDate(endDate, 'YYYY-MM-DD')
				];
				
				this.form.insured_days = finalDays;
				
				// 只有在用户输入超过限制且未自动调整时才提示
				if (this.maxInsuredDays > 0 && days > this.maxInsuredDays && days !== finalDays) {
					this.$message.warning(`保险天数已自动调整为最大${this.maxInsuredDays}天`);
				}
			},
			createOrder(form) {
				if (!this.validateForm(form)) {
					return;
				}

				// 准备提交数据
				const submitData = {
					...form,
					goods_id: this.data.id,
					goods_specs_id: this.data.specs[this.form.specsIndex].id,
				};
				this.$post('app-order', {
					data: JSON.stringify(submitData)
				}).then(res => {
					this.$success('下单成功');
					setTimeout(() => {
						this.$navto('/my/insureDetail?id=' + res.data.order_id)
					}, 1000);
				}).catch(err => {
					this.$message.error(err);
				});
			},

			// 完整的表单验证方法
			validateForm(form) {
				// 1. 验证保险周期
				if (!form.pln_date || form.pln_date.length !== 2) {
					this.$message.error('请选择投保日期范围');
					return false;
				}

				if (!form.pln_time) {
					this.$message.error('请选择起保时刻');
					return false;
				}

				if (form.insured_days <= 0) {
					this.$message.error('保险天数必须大于0');
					return false;
				}

				// 检查是否超过最大天数
				if (this.maxInsuredDays > 0 && form.insured_days > this.maxInsuredDays) {
					this.$message.error(`保险天数不能超过${this.maxInsuredDays}天`);
					return false;
				}

				// 2. 验证投保人信息
				if (!this.validateApplicantInfo(form.applicant_info)) {
					return false;
				}

				// 3. 验证被保人信息
				if (form.insured.length === 0) {
					this.$message.error('请至少添加一个被保人');
					return false;
				}

				// 4. 验证协议同意状态
				if (!this.agreement.a || !this.agreement.b) {
					this.$message.error('请阅读并同意所有相关协议');
					return false;
				}

				// 5. 验证金额
				const amount = parseFloat(this.calculatedAmount);
				if (amount <= 0) {
					this.$message.error('订单金额计算错误，请检查保险天数或被保人信息');
					return false;
				}

				return true;
			},

			// 验证投保人信息
			validateApplicantInfo(applicantInfo) {
				// 验证投保人类型
				if (applicantInfo.applicant_type === undefined || applicantInfo.applicant_type === null) {
					this.$message.error('请选择投保人类型');
					return false;
				}

				// 个人投保人验证
				if (applicantInfo.applicant_type === 0) {
					return this.validatePersonalApplicant(applicantInfo);
				}
				// 企业投保人验证
				else if (applicantInfo.applicant_type === 1) {
					return this.validateCompanyApplicant(applicantInfo);
				}

				return true;
			},

			// 验证个人投保人
			validatePersonalApplicant(applicantInfo) {
				// 验证姓名
				if (!applicantInfo.applicant_name || applicantInfo.applicant_name.trim() === '') {
					this.$message.error('请输入投保人姓名');
					return false;
				}

				if (applicantInfo.applicant_name.length > 50) {
					this.$message.error('投保人姓名长度不能超过50个字符');
					return false;
				}

				// 验证证件类型
				if (applicantInfo.applicant_id_type === undefined || applicantInfo.applicant_id_type === null) {
					this.$message.error('请选择证件类型');
					return false;
				}

				// 个人证件类型只能是 0,1,3,4
				const validPersonalIdTypes = [0, 1, 3, 4];
				if (!validPersonalIdTypes.includes(applicantInfo.applicant_id_type)) {
					this.$message.error('个人投保人证件类型选择错误');
					return false;
				}

				// 验证证件号码
				if (!applicantInfo.applicant_id_number || applicantInfo.applicant_id_number.trim() === '') {
					this.$message.error('请输入证件号码');
					return false;
				}

				// 根据证件类型验证格式
				if (!this.validateIdNumber(applicantInfo.applicant_id_type, applicantInfo.applicant_id_number)) {
					return false;
				}

				// 验证联系电话
				if (!applicantInfo.applicant_phone || applicantInfo.applicant_phone.trim() === '') {
					this.$message.error('请输入联系电话');
					return false;
				}

				// 验证手机号格式
				const phoneRegex = /^1[3-9]\d{9}$/;
				if (!phoneRegex.test(applicantInfo.applicant_phone)) {
					this.$message.error('请输入正确的手机号码格式');
					return false;
				}

				return true;
			},

			// 验证企业投保人
			validateCompanyApplicant(applicantInfo) {
				// 验证企业名称
				if (!applicantInfo.applicant_name || applicantInfo.applicant_name.trim() === '') {
					this.$message.error('请输入企业名称');
					return false;
				}

				if (applicantInfo.applicant_name.length > 100) {
					this.$message.error('企业名称长度不能超过100个字符');
					return false;
				}

				// 验证证件类型 - 企业必须是统一社会信用代码 (2)
				if (applicantInfo.applicant_id_type !== 2) {
					this.$message.error('企业投保人证件类型必须选择统一社会信用代码');
					return false;
				}

				// 验证统一社会信用代码
				if (!applicantInfo.applicant_id_number || applicantInfo.applicant_id_number.trim() === '') {
					this.$message.error('请输入统一社会信用代码');
					return false;
				}

				// 验证统一社会信用代码格式
				const usccRegex = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
				if (!usccRegex.test(applicantInfo.applicant_id_number)) {
					this.$message.error('请输入正确的统一社会信用代码格式');
					return false;
				}

				// 验证联系人
				if (!applicantInfo.applicant_contact_name || applicantInfo.applicant_contact_name.trim() === '') {
					this.$message.error('请输入联系人姓名');
					return false;
				}

				if (applicantInfo.applicant_contact_name.length > 50) {
					this.$message.error('联系人姓名长度不能超过50个字符');
					return false;
				}

				// 验证联系电话
				if (!applicantInfo.applicant_phone || applicantInfo.applicant_phone.trim() === '') {
					this.$message.error('请输入联系电话');
					return false;
				}

				// 验证手机号格式
				const phoneRegex = /^1[3-9]\d{9}$/;
				if (!phoneRegex.test(applicantInfo.applicant_phone)) {
					this.$message.error('请输入正确的手机号码格式');
					return false;
				}

				return true;
			},

			// 验证证件号码格式
			validateIdNumber(idType, idNumber) {
				switch (idType) {
					case 0: // 身份证
						const idCardRegex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
						if (!idCardRegex.test(idNumber)) {
							this.$message.error('请输入正确的身份证号码格式');
							return false;
						}
						break;

					case 1: // 护照
						if (idNumber.length < 5 || idNumber.length > 20) {
							this.$message.error('护照号码长度应在5-20个字符之间');
							return false;
						}
						break;

					case 3: // 港澳居民往来内地通行证
						const hkMacauRegex = /^[HM][0-9]{8}[0-9A-Z]$/;
						if (!hkMacauRegex.test(idNumber)) {
							this.$message.error('请输入正确的港澳居民往来内地通行证');
							return false;
						}
						break;

					case 4: // 台湾居民往来大陆通行证
						const taiwanRegex = /^[0-9]{8}[A-Z]?$/;
						if (!taiwanRegex.test(idNumber)) {
							this.$message.error('请输入正确的台湾居民往来大陆通行证');
							return false;
						}
						break;

					case 2: // 统一社会信用代码
						const usccRegex = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
						if (!usccRegex.test(idNumber)) {
							this.$message.error('请输入正确的统一社会信用代码格式');
							return false;
						}
						break;

					default:
						this.$message.error('未知的证件类型');
						return false;
				}

				return true;
			},

			// 被保人相关方法
			addInsured() {
				this.resetInsuredForm();
				this.insuredShow = true;
			},

			modifyInsured(item) {
				this.insured = {
					...item,
					isEdit: true
				};
				this.insuredShow = true;
			},

			saveInsured() {
				if (!this.validateInsured()) {
					return;
				}

				// 检查是否已存在相同证件号码的被保人（排除当前正在编辑的）
				const existingIndex = this.form.insured.findIndex(item =>
					item.isrd_cret_code === this.insured.isrd_cret_code &&
					!(this.insured.isEdit && item === this.form.insured.find(i => i.isrd_cret_code === this.insured
						.isrd_cret_code))
				);

				if (existingIndex !== -1) {
					this.$message.error('已存在相同证件号码的被保人');
					return;
				}

				if (this.insured.isEdit) {
					// 修改模式
					const index = this.form.insured.findIndex(item => item.isrd_cret_code === this.insured.isrd_cret_code);
					if (index !== -1) {
						const updatedInsured = {
							...this.insured
						};
						delete updatedInsured.isEdit;
						this.form.insured.splice(index, 1, updatedInsured);
						this.$message.success('修改成功');
					}
				} else {
					// 添加模式
					const newInsured = {
						...this.insured,
						id: Date.now() + Math.random().toString(36).substr(2, 9)
					};
					delete newInsured.isEdit;
					this.form.insured.push(newInsured);
					this.$message.success('添加成功');
				}

				this.insuredShow = false;
				this.resetInsuredForm();
			},

			deleteInsured(index) {
				this.$confirm('确定要删除该被保人吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.form.insured.splice(index, 1);
					this.$message.success('删除成功');
				}).catch(() => {
					// 用户取消删除
				});
			},

			deleteAllInsured() {
				if (this.form.insured.length === 0) {
					this.$message.warning('没有可删除的被保人');
					return;
				}

				this.$confirm('确定要删除全部被保人吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.form.insured = [];
					this.$message.success('全部删除成功');
				}).catch(() => {
					// 用户取消删除
				});
			},

			validateInsured() {
				if (!this.insured.isrd_name || this.insured.isrd_name.trim() === '') {
					this.$message.error('请输入被保人姓名');
					return false;
				}

				if (this.insured.isrd_cret_type === undefined || this.insured.isrd_cret_type === null) {
					this.$message.error('请选择证件类型');
					return false;
				}

				if (!this.insured.isrd_cret_code || this.insured.isrd_cret_code.trim() === '') {
					this.$message.error('请输入证件号码');
					return false;
				}

				// 使用统一的证件号码验证方法
				if (!this.validateIdNumber(this.insured.isrd_cret_type, this.insured.isrd_cret_code)) {
					return false;
				}

				if (!this.insured.isrd_telnumber || this.insured.isrd_telnumber.trim() === '') {
					this.$message.error('请输入手机号');
					return false;
				}

				// 简单的手机号格式验证
				const phoneRegex = /^1[3-9]\d{9}$/;
				if (!phoneRegex.test(this.insured.isrd_telnumber)) {
					this.$message.error('请输入正确的手机号码格式');
					return false;
				}

				return true;
			},

			resetInsuredForm() {
				this.insured = {
					isrd_name: '',
					isrd_cret_type: 0,
					isrd_cret_code: '',
					isrd_telnumber: '',
					isEdit: false
				};
			},

			// 粘贴名单相关方法
			saveInsuredList() {
				if (!this.insuredList || this.insuredList.trim() === '') {
					this.$message.error('请输入被保人名单');
					return;
				}

				const lines = this.insuredList.trim().split('\n');
				const newInsuredList = [];
				const errors = [];
				let successCount = 0;
				let skipCount = 0;

				lines.forEach((line, index) => {
					const lineNumber = index + 1;

					// 跳过空行
					if (line.trim() === '') {
						skipCount++;
						return;
					}

					// 改进的分割逻辑：使用正则表达式，确保证件类型、证件号码、手机号不会被错误分割
					const parts = line.trim().match(/(?:[^\s"]+|"[^"]*")+/g) || [];

					// 检查格式：至少需要4个部分
					if (parts.length < 4) {
						errors.push(`第${lineNumber}行：格式错误，需要4个信息（姓名 证件类型 证件号码 手机号），当前只有${parts.length}个`);
						return;
					}

					// 处理姓名：合并除最后3个部分外的所有部分作为姓名
					let nameParts = [];
					let idTypeStr, idNumber, phone;

					if (parts.length === 4) {
						// 标准格式：姓名 证件类型 证件号码 手机号
						nameParts = [parts[0]];
						idTypeStr = parts[1];
						idNumber = parts[2];
						phone = parts[3];
					} else {
						// 姓名包含空格的情况：除最后3个部分外都是姓名
						nameParts = parts.slice(0, parts.length - 3);
						idTypeStr = parts[parts.length - 3];
						idNumber = parts[parts.length - 2];
						phone = parts[parts.length - 1];
					}

					const name = nameParts.join(' ').replace(/^"|"$/g, '').replace(/^'|'$/g, ''); // 移除可能的引号

					// 验证姓名
					if (!name || name.trim() === '') {
						errors.push(`第${lineNumber}行：姓名不能为空`);
						return;
					}

					if (name.length > 50) {
						errors.push(`第${lineNumber}行：姓名长度不能超过50个字符`);
						return;
					}

					// 转换证件类型
					let idType;
					const idTypeMap = {
						'身份证': 0,
						'护照': 1,
						'港澳居民往来内地通行证': 3,
						'台湾居民往来大陆通行证': 4
					};

					if (!idTypeMap.hasOwnProperty(idTypeStr)) {
						errors.push(`第${lineNumber}行：证件类型"${idTypeStr}"无效，只能为"身份证"、"护照"、"港澳居民往来内地通行证"、"台湾居民往来大陆通行证"`);
						return;
					}
					idType = idTypeMap[idTypeStr];

					// 验证证件号码
					if (!idNumber || idNumber.trim() === '') {
						errors.push(`第${lineNumber}行：证件号码不能为空`);
						return;
					}

					if (idNumber.length > 30) {
						errors.push(`第${lineNumber}行：证件号码长度不能超过30个字符`);
						return;
					}

					// 证件号码格式验证
					if (!this.validateIdNumber(idType, idNumber)) {
						errors.push(`第${lineNumber}行：证件号码格式不正确`);
						return;
					}

					// 验证手机号
					if (!phone || phone.trim() === '') {
						errors.push(`第${lineNumber}行：手机号不能为空`);
						return;
					}

					const phoneRegex = /^1[3-9]\d{9}$/;
					if (!phoneRegex.test(phone)) {
						errors.push(`第${lineNumber}行：手机号"${phone}"格式不正确`);
						return;
					}

					// 检查是否已存在相同证件号码的被保人
					const existingInsured = this.form.insured.find(item => item.isrd_cret_code === idNumber);
					if (existingInsured) {
						errors.push(`第${lineNumber}行：证件号码 ${idNumber} 已存在（${existingInsured.isrd_name}）`);
						return;
					}

					// 检查当前批次内是否重复
					const duplicateInBatch = newInsuredList.find(item => item.isrd_cret_code === idNumber);
					if (duplicateInBatch) {
						errors.push(`第${lineNumber}行：证件号码 ${idNumber} 在当前批次中重复`);
						return;
					}

					// 创建被保人对象
					const insured = {
						id: Date.now() + Math.random().toString(36).substr(2, 9) + index,
						isrd_name: name,
						isrd_cret_type: idType,
						isrd_cret_code: idNumber,
						isrd_telnumber: phone
					};

					newInsuredList.push(insured);
					successCount++;
				});

				// 处理结果
				if (errors.length > 0) {
					const errorMessage = errors.slice(0, 10).join('\n'); // 只显示前10个错误
					let resultMessage = `处理完成：成功 ${successCount} 个，失败 ${errors.length} 个，跳过空行 ${skipCount} 个`;

					if (errors.length > 10) {
						resultMessage += `\n\n前10个错误：\n${errorMessage}\n...（还有${errors.length - 10}个错误）`;
					} else {
						resultMessage += `\n\n错误详情：\n${errorMessage}`;
					}

					if (successCount > 0) {
						// 如果有成功的记录，仍然添加
						this.form.insured.push(...newInsuredList);
						this.$message.success(resultMessage);
					} else {
						this.$message.error(resultMessage);
					}
				} else {
					if (successCount > 0) {
						this.form.insured.push(...newInsuredList);
						this.$message.success(`成功添加 ${successCount} 个被保人${skipCount > 0 ? `，跳过 ${skipCount} 个空行` : ''}`);
					} else {
						this.$message.warning('没有有效的被保人信息');
					}
				}

				// 关闭弹窗并清空内容
				this.insuredListShow = false;
				this.insuredList = '';
			},

			clearInsuredList() {
				this.insuredList = '';
				this.$message.info('已清空粘贴内容');
			},

			// Excel上传相关方法
			triggerUpload() {
				this.$refs.excelUpload.$el.querySelector('input').click();
			},

			beforeExcelUpload(file) {
				const isExcel = file.type === 'application/vnd.ms-excel' ||
					file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
					file.type === 'text/csv' ||
					file.name.endsWith('.xlsx') ||
					file.name.endsWith('.xls') ||
					file.name.endsWith('.csv');

				const isLt10M = file.size / 1024 / 1024 < 10;

				if (!isExcel) {
					this.$message.error('只能上传 Excel 或 CSV 文件!');
					return false;
				}
				if (!isLt10M) {
					this.$message.error('文件大小不能超过 10MB!');
					return false;
				}

				this.uploadLoading = this.$loading({
					lock: true,
					text: '正在解析 Excel 文件...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});

				this.readExcelFile(file);
				return false;
			},

			readExcelFile(file) {
				const reader = new FileReader();

				reader.onload = (e) => {
					try {
						const data = new Uint8Array(e.target.result);
						const workbook = XLSX.read(data, {
							type: 'array'
						});

						const firstSheetName = workbook.SheetNames[0];
						const worksheet = workbook.Sheets[firstSheetName];

						const jsonData = XLSX.utils.sheet_to_json(worksheet, {
							header: 1
						});

						this.processExcelData(jsonData);

					} catch (error) {
						this.$message.error('Excel 文件解析失败，请检查文件格式');
					} finally {
						if (this.uploadLoading) {
							this.uploadLoading.close();
						}
					}
				};

				reader.onerror = () => {
					this.$message.error('文件读取失败');
					if (this.uploadLoading) {
						this.uploadLoading.close();
					}
				};

				reader.readAsArrayBuffer(file);
			},

			processExcelData(excelData) {
				if (!excelData || excelData.length === 0) {
					this.$message.warning('Excel 文件为空');
					return;
				}

				const newInsuredList = [];
				const errors = [];
				let successCount = 0;
				let skipCount = 0;

				let startRow = 0;
				if (excelData.length > 0) {
					const firstRow = excelData[0];
					if (firstRow.some(cell =>
							cell && typeof cell === 'string' &&
							(cell.includes('姓名') || cell.includes('证件') || cell.includes('手机'))
						)) {
						startRow = 1;
					}
				}

				for (let i = startRow; i < excelData.length; i++) {
					const row = excelData[i];
					const lineNumber = i + 1;

					if (!row || row.length === 0 || row.every(cell => !cell || cell.toString().trim() === '')) {
						skipCount++;
						continue;
					}

					try {
						const insured = this.parseExcelRow(row, lineNumber);
						if (insured) {
							newInsuredList.push(insured);
							successCount++;
						}
					} catch (error) {
						errors.push(`第${lineNumber}行：${error.message}`);
					}
				}

				this.handleImportResult(newInsuredList, errors, successCount, skipCount);
			},

			parseExcelRow(row, lineNumber) {
				const filledRow = [...row];
				while (filledRow.length < 4) {
					filledRow.push('');
				}

				const name = filledRow[0] ? filledRow[0].toString().trim() : '';
				const idTypeStr = filledRow[1] ? filledRow[1].toString().trim() : '';
				const idNumber = filledRow[2] ? filledRow[2].toString().trim() : '';
				const phone = filledRow[3] ? filledRow[3].toString().trim() : '';

				if (!name) {
					throw new Error('姓名为空');
				}

				if (!idTypeStr) {
					throw new Error('证件类型为空');
				}

				if (!idNumber) {
					throw new Error('证件号码为空');
				}

				if (!phone) {
					throw new Error('手机号为空');
				}

				const idTypeMap = {
					'身份证': 0,
					'护照': 1,
					'港澳居民往来内地通行证': 3,
					'台湾居民往来大陆通行证': 4,
					'0': 0,
					'1': 1,
					'3': 3,
					'4': 4
				};

				if (!idTypeMap.hasOwnProperty(idTypeStr)) {
					throw new Error(`无效的证件类型: ${idTypeStr}`);
				}
				const idType = idTypeMap[idTypeStr];

				// 使用统一的证件号码验证
				if (!this.validateIdNumber(idType, idNumber)) {
					throw new Error('证件号码格式不正确');
				}

				const phoneRegex = /^1[3-9]\d{9}$/;
				if (!phoneRegex.test(phone)) {
					throw new Error('手机号格式不正确');
				}

				const existingInsured = this.form.insured.find(item =>
					item.isrd_cret_code === idNumber
				);
				if (existingInsured) {
					throw new Error(`证件号码 ${idNumber} 已存在`);
				}

				return {
					id: Date.now() + Math.random().toString(36).substr(2, 9) + lineNumber,
					isrd_name: name,
					isrd_cret_type: idType,
					isrd_cret_code: idNumber,
					isrd_telnumber: phone
				};
			},

			handleImportResult(newInsuredList, errors, successCount, skipCount) {
				if (errors.length > 0) {
					const errorMessage = errors.slice(0, 10).join('\n');
					let resultMessage = `处理完成：成功 ${successCount} 个，失败 ${errors.length} 个，跳过空行 ${skipCount} 个`;

					if (errors.length > 10) {
						resultMessage += `\n\n前10个错误：\n${errorMessage}\n...（还有${errors.length - 10}个错误）`;
					} else {
						resultMessage += `\n\n错误详情：\n${errorMessage}`;
					}

					if (successCount > 0) {
						this.form.insured.push(...newInsuredList);
						this.$message.success(resultMessage);
					} else {
						this.$message.error(resultMessage);
					}
				} else {
					if (successCount > 0) {
						this.form.insured.push(...newInsuredList);
						this.$message.success(`成功导入 ${successCount} 个被保人${skipCount > 0 ? `，跳过 ${skipCount} 个空行` : ''}`);
					} else {
						this.$message.warning('没有找到有效的被保人数据');
					}
				}
			},

			downloadTemplate() {
				const templateData = [
					['姓名', '证件类型', '证件号码', '手机号'],
					['张三', '身份证', '320125198006030000', '13800138000'],
					['Bruce Lee', '护照', 'L23485839', '13800138001'],
					['李四', '港澳居民往来内地通行证', 'H12345678', '13800138003'],
					['王五', '台湾居民往来大陆通行证', 'T12345678', '13800138004']
				];

				const wb = XLSX.utils.book_new();
				const ws = XLSX.utils.aoa_to_sheet(templateData);

				const colWidths = [{
						wch: 20
					},
					{
						wch: 15
					},
					{
						wch: 25
					},
					{
						wch: 15
					}
				];
				ws['!cols'] = colWidths;

				XLSX.utils.book_append_sheet(wb, ws, '被保人模板');
				XLSX.writeFile(wb, '被保人导入模板.xlsx');
			},

			exportAllInsured() {
				if (this.form.insured.length === 0) {
					this.$message.warning('没有可导出的被保人数据');
					return;
				}

				const exportData = [
					['姓名', '证件类型', '证件号码', '手机号']
				];

				this.form.insured.forEach(insured => {
					const idTypeMap = {
						0: '身份证',
						1: '护照',
						3: '港澳居民往来内地通行证示例',
						4: '台湾居民往来大陆通行证'
					};

					exportData.push([
						insured.isrd_name,
						idTypeMap[insured.isrd_cret_type] || '未知',
						insured.isrd_cret_code,
						insured.isrd_telnumber
					]);
				});

				const wb = XLSX.utils.book_new();
				const ws = XLSX.utils.aoa_to_sheet(exportData);

				const colWidths = [{
						wch: 20
					},
					{
						wch: 15
					},
					{
						wch: 25
					},
					{
						wch: 15
					}
				];
				ws['!cols'] = colWidths;

				XLSX.utils.book_append_sheet(wb, ws, '被保人列表');
				XLSX.writeFile(wb, `被保人列表_${new Date().getTime()}.xlsx`);
				this.$message.success(`成功导出 ${this.form.insured.length} 个被保人`);
			},

			// 工具方法
			getTomorrow() {
				const tomorrow = new Date();
				tomorrow.setDate(tomorrow.getDate() + 1);
				tomorrow.setHours(0, 0, 0, 0);
				return tomorrow;
			},
			addDays(date, days) {
				const result = new Date(date);
				result.setDate(result.getDate() + days);
				return result;
			},
			getDaysBetweenDates(startDate, endDate) {
				if (!startDate || !endDate) return 0;
				const start = new Date(startDate);
				const end = new Date(endDate);
				const timeDiff = end.getTime() - start.getTime();
				return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
			},

			// 工具函数：安全转换为整数
			$toInt(value, defaultValue = 0) {
				if (value === null || value === undefined || value === '') {
					return defaultValue;
				}
				const num = parseInt(value, 10);
				return isNaN(num) ? defaultValue : num;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		background-color: #F7F7F7;
		padding-bottom: 200px;

		/* 笔记本屏幕适配 */
		@media (min-width: 1024px) and (max-width: 1440px) {
			padding-bottom: 180px;
		}

		.dialog-footer {
			.el-button {
				width: 120px;
				line-height: 20px;
				border-radius: 50px;
			}
		}

		.content {
			margin: 20px auto 40px;
			width: 68%;

			/* 笔记本屏幕适配 */
			@media (min-width: 1024px) and (max-width: 1440px) {
				width: 85%;
				margin: 15px auto 30px;
			}

			.header {
				display: flex;
				align-items: center;
				justify-content: space-between;
				background-color: #fff;
				border-radius: 10px;
				padding: 20px;
				margin-top: 20px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					padding: 18px;
					margin-top: 18px;
					border-radius: 8px;
				}

				.header-left {
					.header-title {
						font-size: 22px;
						font-weight: bold;
						color: #333333;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							font-size: 20px;
						}
					}

					.header-value {
						color: #999999;
						font-size: 18px;
						margin-top: 5px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							font-size: 16px;
						}
					}
				}

				.header-right {
					span {
						color: #666666;
						font-size: 16px;
						cursor: pointer;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							font-size: 15px;
						}
					}
				}
			}

			.box {
				background-color: #fff;
				border-radius: 10px;
				padding: 20px;
				margin-top: 20px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					padding: 18px;
					margin-top: 18px;
					border-radius: 8px;
				}

				.box-header {
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-bottom: 10px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						flex-direction: column;
						align-items: flex-start;
						gap: 15px;
					}

					.box-header-left {
						display: flex;
						align-items: center;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							width: 100%;
							justify-content: space-between;
						}

						.box-title {
							color: #333333;
							font-size: 20px;
							font-weight: bold;
							width: 120px;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								font-size: 18px;
								width: auto;
							}
						}

						.box-tips {
							color: #FF2B2B;
							font-size: 14px;
							cursor: pointer;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								font-size: 13px;
							}

							i {
								margin-right: 5px;
							}
						}
					}

					.box-header-right {
						display: flex;
						gap: 10px;
						align-items: center;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							width: 100%;
							justify-content: flex-start;
							flex-wrap: wrap;
							gap: 8px;
						}

						.operate {
							color: #2280FD;
							font-size: 14px;
							cursor: pointer;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								font-size: 13px;
							}
						}

						.operate-line {
							height: 12px;
							border: 1px solid #CCCCCC;
							width: 1px;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								height: 10px;
							}
						}

						.del {
							color: #FF2B2B;
						}
					}
				}

				.form {
					margin-top: 10px;

					.el-form-item {
						width: 600px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							width: 100%;
							margin-bottom: 15px;
						}

						.el-input {
							width: 400px;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								width: 100%;
							}
						}

						::v-deep .el-form-item__label {
							color: #999999 !important;
							font-size: 16px;
							width: 120px;
							text-align: left;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								font-size: 15px;
								width: 110px;
							}
						}
					}

					// 新增：最长投保天数提示样式
					.max-days-tip {
						margin-left: 10px;
						color: #999;
						font-size: 14px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							font-size: 13px;
							margin-left: 8px;
						}
					}
				}

				.invoice-tips {
					color: #999999;
					font-size: 14px;
					margin-top: 5px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 13px;
					}
				}

				.user-list {
					width: 100%;
					display: flex;
					gap: 15px;
					flex-wrap: wrap;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						gap: 12px;
					}

					.user-item {
						width: calc(50% - 8px);
						padding: 10px;
						border-radius: 5px;
						border: 1px solid #CCCCCC;
						display: flex;
						justify-content: space-between;
						align-items: center;
						font-size: 14px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							width: 100%;
							font-size: 13px;
							padding: 8px;
						}

						.user-info {
							display: flex;
							gap: 10px;
							align-items: center;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								gap: 8px;
							}

							.user-name {
								color: #333333;
							}

							.user-id {
								color: #999999;
							}
						}

						.user-operate {
							display: flex;
							gap: 10px;
							align-items: center;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								gap: 8px;
							}

							.user-operate-btn {
								color: #2280FD;
								cursor: pointer;
							}

							.del {
								color: #FF2B2B;
							}
						}
					}

					.empty-tips {
						width: 100%;
						text-align: center;
						color: #999999;
						font-size: 14px;
						padding: 20px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							font-size: 13px;
							padding: 15px;
						}
					}
				}

				.textarea {
					width: 50%;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						width: 100%;
					}
				}

				.explain {
					color: #666666;
					font-size: 14px;
					border-top: 1px solid #EEEEEE;
					padding-top: 15px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 13px;
						padding-top: 12px;
					}
				}

				.read {
					color: #666666;
					font-size: 16px;
					display: flex;
					margin-top: 10px;
					align-items: baseline;
					color: #666666;
					gap: 6px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 15px;
						margin-top: 8px;
					}

					i {
						font-size: 18px;
						cursor: pointer;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							font-size: 16px;
						}
					}

					span {
						color: #2280FD;
						cursor: pointer;
					}
				}
			}
		}

		.bottom {
			position: fixed;
			z-index: 99;
			bottom: 0;
			width: 100%;
			padding: 15px 16%;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			background-color: #fff;
			border-top: 1px solid #EEEEEE;
			gap: 20px;

			/* 笔记本屏幕适配 */
			@media (min-width: 1024px) and (max-width: 1440px) {
				padding: 12px 12%;
				gap: 15px;
			}

			.amount {
				color: #FF2B2B;
				font-size: 28px;
				font-weight: bold;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					font-size: 24px;
				}

				span {
					font-weight: 500;
					font-size: 16px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 14px;
					}
				}
			}

			.bottom-btn {
				background-color: #2280FD;
				color: #fff;
				width: 120px;
				line-height: 40px;
				border-radius: 50px;
				text-align: center;
				cursor: pointer;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					width: 110px;
					line-height: 36px;
					font-size: 15px;
				}
			}
		}
	}

	// 粘贴名单弹窗样式
	.paste-tips {
		background-color: #f0f8ff;
		border: 1px solid #2280FD;
		border-radius: 4px;
		padding: 12px;
		margin-bottom: 16px;

		/* 笔记本屏幕适配 */
		@media (min-width: 1024px) and (max-width: 1440px) {
			padding: 10px;
		}

		.tip-title {
			font-weight: bold;
			color: #2280FD;
			margin-bottom: 8px;
			font-size: 14px;

			/* 笔记本屏幕适配 */
			@media (min-width: 1024px) and (max-width: 1440px) {
				font-size: 13px;
			}
		}

		.tip-content {
			font-size: 13px;
			color: #666;
			line-height: 1.5;

			/* 笔记本屏幕适配 */
			@media (min-width: 1024px) and (max-width: 1440px) {
				font-size: 12px;
			}

			p {
				margin: 4px 0;
			}

			strong {
				color: #333;
			}
		}
	}

	// 上传组件样式
	.excel-upload {
		display: none;
	}

	// 历史投保人样式
	.historical-applicants {
		.search-box {
			margin-bottom: 20px;
			
			.el-input {
				width: 100%;
			}
		}

		.applicants-list {
			max-height: 400px;
			overflow-y: auto;

			.applicant-item {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 12px 16px;
				border: 1px solid #e8e8e8;
				border-radius: 6px;
				margin-bottom: 10px;
				cursor: pointer;
				transition: all 0.3s;

				&:hover {
					border-color: #2280FD;
					background-color: #f5f9ff;
				}

				.applicant-info {
					flex: 1;
					
					.applicant-name {
						font-weight: bold;
						color: #333;
						margin-bottom: 4px;
						font-size: 16px;
					}

					.applicant-details {
						display: flex;
						flex-wrap: wrap;
						gap: 12px;
						font-size: 12px;
						color: #666;

						.applicant-type {
							background: #e8f4ff;
							color: #2280FD;
							padding: 2px 6px;
							border-radius: 3px;
							font-weight: bold;
						}

						.applicant-id,
						.applicant-phone,
						.applicant-time {
							background: #f5f5f5;
							padding: 2px 6px;
							border-radius: 3px;
						}
					}
				}

				.applicant-action {
					.el-button {
						min-width: 60px;
					}
				}
			}

			.empty-state,
			.loading-state {
				text-align: center;
				padding: 40px;
				color: #999;

				i {
					font-size: 48px;
					margin-bottom: 16px;
					display: block;
				}

				p {
					margin: 0;
					font-size: 14px;
				}
			}

			.loading-state {
				i {
					animation: rotating 2s linear infinite;
				}
			}

			.pagination {
				margin-top: 20px;
				display: flex;
				justify-content: center;
			}
		}
	}

	@keyframes rotating {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}

	// 响应式适配
	@media (min-width: 1024px) and (max-width: 1440px) {
		.historical-applicants {
			.applicants-list {
				max-height: 350px;
				
				.applicant-item {
					padding: 10px 14px;
					
					.applicant-info {
						.applicant-name {
							font-size: 15px;
						}
						
						.applicant-details {
							font-size: 11px;
							gap: 10px;
						}
					}
				}
			}
		}
	}
</style>

<style>
	/* 全局样式 - 用于MessageBox弹框 */
	.explanation-message-box .el-message-box__content {
		max-height: 60vh;
		overflow-y: auto;
	}

	.message-box-content {
		text-align: left;
	}

	.message-box-content h3 {
		color: #333;
		margin-bottom: 16px;
		font-size: 18px;
		border-bottom: 1px solid #eee;
		padding-bottom: 8px;
	}

	.message-box-content h4 {
		color: #666;
		margin: 12px 0 8px 0;
		font-size: 16px;
	}

	.message-box-content ul {
		margin: 8px 0;
		padding-left: 20px;
	}

	.message-box-content li {
		margin-bottom: 6px;
		line-height: 1.5;
		color: #666;
	}

	.message-box-content .important-tips {
		background-color: #fff8e6;
		border: 1px solid #ffd591;
		border-radius: 4px;
		padding: 12px;
		margin-top: 16px;
		color: #d46b08;
	}

	.message-box-content .important-tips strong {
		color: #d46b08;
	}
</style>